import { Component, Prop, Vue } from 'types-vue'

@Component
export default class Title extends Vue {
  @Prop({ type: Boolean, default: false }) protected loading: boolean
}